/**
 *  Extends Item Model to use a different fieldes in order to load specifications
**/
define('StellarGrade.ST_Product.ItemDetails.Model.Specifications', [   
    'Item.Model',
    'Facets.Model',
    'Session',
    'underscore'
], function (
    ItemModel,   
    FacetsModel, 
    Session,
    _
) {
    'use strict';

    var ItemModelSpecification = ItemModel;
    var FacetsModelSpecification = FacetsModel.extend({
        url: function() {
            var extendto = _.extend({},this.searchApiMasterOptions, Session.getSearchApiParams(), {fieldset: 'specifications'});
            delete extendto.include;
            var url = _.addParamsToUrl('/api/items', extendto);
            return url;
        }
    });

    return {
        loadModule: function () {
            ItemModelSpecification.prototype.searchApiMasterOptions =  _.extend({}, ItemModel.prototype.searchApiMasterOptions, {
                fieldset: 'specifications'
            });
        },

        model: ItemModelSpecification,
        facetsModel: FacetsModelSpecification
    }
});
